<div class="modal-dialog" [ngClass]="{'modal-fullscreen-custom': isFullscreen}">
  <div class="modal-content">
    <!-- Header -->
    <div class="modal-header d-flex justify-content-between align-items-center">
      <h5 class="modal-title">პოსტის რედაქტირება</h5>
      <div class="d-flex gap-2">
        <!-- Fullscreen Toggle -->
        <button type="button"
                class="btn btn-full-creen"
                (click)="toggleFullscreen()">
                <i class="fi fi-rr-expand"></i>
        </button>
        <!-- Close -->
        <button type="button"
                class="btn-close"
                aria-label="Close"
                (click)="closeModal.emit()"></button>
      </div>
    </div>

    <div class="modal-body">
      <form [formGroup]="pageForm">
      
        <div class="form-floating mb-3">
          <input
            type="text"
            class="form-control"
            formControlName="title"
            id="title"
            placeholder="სათაური"
            required>
          <label for="title">სათაური</label>
          <div class="invalid-feedback">
            error
          </div>
        </div>

        <div class="form-floating mb-3">
            <select formControlName="menu_page" class="form-select" >
              <option *ngFor="let itm of selectedItems" [value]="itm.menu_page">
              {{ itm.menu?.title || itm.title }} 
              </option>
            </select>
            <label for="menuid">მენიუ</label>
        </div>
      

          <div class="form-floating mb-3">
            <input
              type="datetime-local"
              class="form-control"
              formControlName="add_date"
              id="add_date"
              placeholder="თარიღი"
              required>
            <label for="add_date">თარიღი</label>
            <div class="invalid-feedback">
              error
            </div>
          </div>
 
          <app-text-editor formControlName="content"></app-text-editor>
          


          <div class="mt-3 mb-3">
            <app-upload
              *ngIf="editingPageId"
              [uploadPath]="getListUploadPath()"
              (uploaded)="onFileUploaded($event)">
            </app-upload>
          </div>

            <!-- ================= IMAGES ================= -->
            <div class="card mb-3" *ngIf="editingPageId">
              <div class="card-header d-flex align-items-center justify-content-between">
                <div class="fw-bold">სურათები</div>

                <div class="text-muted small" *ngIf="sorting">
                  სორტირება ინახება...
                </div>
              </div>

              <div class="card-body">

                <div class="alert alert-info" *ngIf="!imageItemsArr.length">
                  სურათები ჯერ არ გაქვს დამატებული
                </div>

                <div class="table-responsive" *ngIf="imageItemsArr.length">
                  <table class="table table-bordered align-middle">
                    <thead>
                      <tr>
                        <th style="width:60px;">#</th>
                        <th style="width:60px;">⇅</th>
                        <th style="width:90px;">Preview</th>
                        <th>ფაილი</th>
                        <th style="width:170px;">ქმედება</th>
                      </tr>
                    </thead>

                    <tbody cdkDropList [cdkDropListData]="imageItemsArr" (cdkDropListDropped)="dropImages($event)">
                      <tr *ngFor="let img of imageItemsArr; let i = index" cdkDrag>
                        <td>{{ i + 1 }}</td>

                        <td class="text-center">
                          <button type="button" class="btn btn-sm btn-light border" cdkDragHandle title="გადაადგილება" style="cursor: grab;">
                            <i class="fi fi-rr-menu-burger"></i>
                          </button>
                        </td>

                        <td>
                          <img
                            *ngIf="img?.url || img?.full_src || img?.src"
                            [src]="getFullImageUrl(img.url || img.full_src || img.src)"
                            style="width:70px;height:70px;object-fit:cover;border-radius:8px;border:1px solid #eee;" />
                          <div *ngIf="!(img?.url || img?.full_src || img?.src)" class="text-muted small">No preview</div>
                        </td>

                        <td class="text-muted small">
                          {{ img.orig_name || img.url || img.full_src || img.src }}
                          <div class="text-muted" style="font-size:12px;">
                            {{ img.url || img.full_src || img.src }}
                          </div>
                          <span class="badge bg-success ms-2" *ngIf="img.pin == 1">MAIN</span>
                        </td>

                        <td>
                          <button class="btn btn-sm btn-outline-success me-2" (click)="setMainImage(img)">
                            მთავარი
                          </button>

                          <button class="btn btn-sm btn-outline-danger" (click)="removeGalleryImage(img.media_id)">
                            წაშლა
                          </button>
                        </td>
                      </tr>
                    </tbody>

                  </table>
                </div>

              </div>
            </div>


            <!-- ================= FILES ================= -->
            <div class="card mb-3" *ngIf="editingPageId">
              <div class="card-header d-flex align-items-center justify-content-between">
                <div class="fw-bold">ფაილები</div>

                <div class="text-muted small" *ngIf="sorting">
                  სორტირება ინახება...
                </div>
              </div>

              <div class="card-body">

                <div class="alert alert-info" *ngIf="!fileItemsArr.length">
                  ფაილები ჯერ არ გაქვს დამატებული
                </div>

                <div class="table-responsive" *ngIf="fileItemsArr.length">
                  <table class="table table-bordered align-middle">
                    <thead>
                      <tr>
                        <th style="width:60px;">#</th>
                        <th style="width:60px;">⇅</th>
                        <th>სახელი</th>
                        <th style="width:220px;">ლინკი</th>
                        <th style="width:220px;">ქმედება</th>
                      </tr>
                    </thead>

                    <!-- აქ იყო galleryItems -->
                    <tbody cdkDropList [cdkDropListData]="fileItemsArr" (cdkDropListDropped)="dropFiles($event)">
                      <tr *ngFor="let f of fileItemsArr; let i = index" cdkDrag>
                        <td>{{ i + 1 }}</td>

                        <td class="text-center">
                          <button type="button"
                                  class="btn btn-sm btn-light border"
                                  cdkDragHandle
                                  title="გადაადგილება"
                                  style="cursor: grab;">
                            <i class="fi fi-rr-menu-burger"></i>
                          </button>
                        </td>

                        <td class="truncate-text">
                          {{ f.title || f.orig_name || 'ფაილი' }}
                          <div class="text-muted" style="font-size:12px;">
                            {{ f.url || f.full_src || f.src }}
                          </div>
                        </td>

                        <td>
                          <a class="btn btn-sm btn-outline-primary"
                            [href]="getFullImageUrl(f.url || f.full_src || f.src)"
                            target="_blank" rel="noopener">
                            გახსნა
                          </a>
                        </td>

                        <td>
                          <button class="btn btn-sm btn-outline-secondary me-2" (click)="renameFile(f)">
                            სახელის შეცვლა
                          </button>

                          <button class="btn btn-sm btn-outline-danger" (click)="removeGalleryImage(f.media_id)">
                            წაშლა
                          </button>
                        </td>
                      </tr>
                    </tbody>

                  </table>
                </div>

              </div>
            </div>


            <!-- ================= VIDEOS ================= -->
<div class="card mb-3" *ngIf="editingPageId">
  <div class="card-header d-flex align-items-center justify-content-between">
    <div class="fw-bold">ვიდეოები</div>

    <div class="text-muted small" *ngIf="sorting">
      სორტირება ინახება...
    </div>
  </div>

  <div class="card-body">

    <div class="alert alert-info" *ngIf="!videoItemsArr.length">
      ვიდეოები ჯერ არ გაქვს დამატებული
    </div>

    <div class="table-responsive" *ngIf="videoItemsArr.length">
      <table class="table table-bordered align-middle">
        <thead>
          <tr>
            <th style="width:60px;">#</th>
            <th style="width:60px;">⇅</th>
            <th style="width:140px;">Preview</th>
            <th>ფაილი</th>
            <th style="width:220px;">ქმედება</th>
          </tr>
        </thead>

        <tbody cdkDropList [cdkDropListData]="videoItemsArr" (cdkDropListDropped)="dropVideos($event)">
          <tr *ngFor="let v of videoItemsArr; let i = index" cdkDrag>
            <td>{{ i + 1 }}</td>

            <td class="text-center">
              <button
                type="button"
                class="btn btn-sm btn-light border"
                cdkDragHandle
                title="გადაადგილება"
                style="cursor: grab;">
                <i class="fi fi-rr-menu-burger"></i>
              </button>
            </td>

            <td>
              <video
                *ngIf="v?.url || v?.full_src || v?.src"
                [src]="getFullImageUrl(v.url || v.full_src || v.src)"
                controls
                preload="metadata"
                style="width:110px;height:70px;object-fit:cover;border-radius:8px;border:1px solid #eee;">
              </video>
              <div *ngIf="!(v?.url || v?.full_src || v?.src)" class="text-muted small">No preview</div>
            </td>

            <td class="text-muted small">
              {{ v.title || v.orig_name || v.url || v.full_src || v.src }}
              <div class="text-muted" style="font-size:12px;">
                {{ v.url || v.full_src || v.src }}
              </div>
            </td>

            <td>
              <a
                class="btn btn-sm btn-outline-primary me-2"
                [href]="getFullImageUrl(v.url || v.full_src || v.src)"
                target="_blank"
                rel="noopener">
                გახსნა
              </a>

              <button class="btn btn-sm btn-outline-secondary me-2" (click)="renameFile(v)">
                სახელის შეცვლა
              </button>

              <button class="btn btn-sm btn-outline-danger" (click)="removeGalleryImage(v.media_id)">
                წაშლა
              </button>
            </td>
          </tr>
        </tbody>

      </table>
    </div>

  </div>
</div>

          <div class="mt-3 mb-3">
             <app-meta-modal [form]="pageForm"></app-meta-modal>
          </div>
  
      </form>
    <div class="modal-footer d-flex justify-content-between">
      <div>
        <span *ngIf="pageForm.get('author')?.value"><b>ავტორი: </b>{{pageForm.get('author')?.value}}</span>
      </div>
      <div>
        <button type="button" class="btn btn-secondary mx-1" (click)="closeModal.emit()">დახურვა</button>
        <button type="button" class="btn btn-primary" (click)="savePage()" [disabled]="loadSave">
          <span *ngIf="loadSave" class="spinner-border spinner-border-sm" role="status" ></span> 
          <span *ngIf="!this.editingPageId">დამატება</span>
          <span *ngIf="this.editingPageId">შენახვა</span>
        </button>
      </div>
    </div>
  </div>
</div>

